<template>
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M17.3917 14.1845L14.418 11.2219C14.9587 10.1446 15.3191 8.88778 15.3191 7.63092C15.3191 3.41147 11.8949 0 7.65957 0C3.42428 0 0 3.41147 0 7.63092C0 11.8504 3.42428 15.2618 7.65957 15.2618C8.92115 15.2618 10.1827 14.9027 11.2641 14.3641L14.2378 17.3267C15.1389 18.2244 16.4906 18.2244 17.3917 17.3267C18.2028 16.4289 18.2028 15.0823 17.3917 14.1845ZM7.65957 13.4663C4.41552 13.4663 1.80225 10.8628 1.80225 7.63092C1.80225 4.399 4.41552 1.79551 7.65957 1.79551C10.9036 1.79551 13.5169 4.399 13.5169 7.63092C13.5169 10.8628 10.9036 13.4663 7.65957 13.4663Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconSearch"
}
</script>